import { FlatList } from 'react-native';

export const BSFlatList = FlatList;
